import React from 'react';
import {ReactComponent as WarningIcon} from 'assets/icons/warning-icon.svg';
import {ReactComponent as InfoIcon} from 'assets/icons/info-icon.svg';
import classNames from 'classnames';
import styles from './RateSummaryAlertCard.module.scss';

export type RateSummaryAlertType = 'warning' | 'info';

interface RateSummaryAlertItem {
    title: string;
    description: string;
    tooltip: string;
    tooltipTitle: string;
    confidence?: number;
}

interface RateSummaryAlertCardProps {
    type: RateSummaryAlertType;
    item: RateSummaryAlertItem;
}

export const RateSummaryAlertCard: React.FC<RateSummaryAlertCardProps> = ({type, item}) => {
    return (
        <div className={classNames(styles.card, styles[type])}>
            <div className={styles.header}>
                {type === 'warning' ? (
                    <WarningIcon className={styles.icon} />
                ) : (
                    <InfoIcon className={styles.icon} />
                )}
                <div className={styles.content}>
                    <h3 className={styles.title}>
                        {item.title}
                        <div className={styles["tooltip-container"]}>
                            <span className={styles.more}>
                                more info
                                <div className={styles.tooltip}>
                                    <h4>
                                        <InfoIcon className={styles.icon} />
                                        {item.tooltipTitle}
                                    </h4>
                                    {item.tooltip}
                                </div>
                            </span>
                        </div>
                    </h3>
                    <p className={styles.description}>
                        {item.description}
                        {item.confidence && (
                            <span> | {item.confidence}% confidence</span>
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
}; 